module.exports = __webpack_public_path__ + "img/tournament-recap-image.019a871b.jpg";